const oldDomain = '//legacy.newsleopard.com';
export const signUpUrl = `${process.env.APP_DOMAIN}/auth/signup`;
export const loginUrl = `${process.env.APP_DOMAIN}/auth/login`;
export const oldLoginUrl = `${oldDomain}/login.htm`;
export const siteDomain = process.env.WEB_DOMAIN;
export const nlApiUrl = '/api/v1/';
export const snApiUrl = '/surenotify/api/v1/';
export const nlProductLink = `${process.env.APP_DOMAIN}`;
export const snProductLink = 'https://app.surenotifyapi.com';
export const apiHost = process.env.API_HOST;